import {Router} from '@angular/router';
import * as _ from 'underscore';
import {Component, OnInit, AfterViewInit} from '@angular/core';
import {IOption} from 'ng-select';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {ValidatorService} from 'angular-iban';
import {DataService} from '../../shared/data.service';
import {ThirdTab} from '../../shared/classes/third-tab.model';
import {FormDataService} from '../../shared/form-data.service';
import {CourierResponse} from '../../shared/classes/courier.model';
import {RightSideService} from '../../shared/right-side.service';
import {ValidateTcNo} from './tcno.validator';
import {NavigationBarService} from '../../shared/navigation-bar.service';
import {storageFactory, detectmob} from '../../../../app-storage';
import {PageContent} from '../../shared/classes/page-content.model';
import hbusApiClient from '../../../../analytics/hbusApiClient';

@Component({
  selector: 'app-third-tab',
  templateUrl: './third-tab.component.html',
  styleUrls: ['./third-tab.component.css'],
  host: {
    class: 'col-md-9 col-lg-9 col-sm-12 col-12'
  }
})
export class ThirdTabComponent implements OnInit, AfterViewInit {
  tabSelected = 3;
  errorTexts: string[] = [];
  cities: Array<IOption> = [];
  districts: Array<IOption> = [];
  towns: Array<IOption> = [];
  citySelected = true;
  contactForm: FormGroup;
  selectedCityId: string;
  seller: ThirdTab = new ThirdTab();
  lastSeller: any;
  selectedCity = false;
  selectedDistrict = false;
  selectedTown = false;
  selectedOrder = false;
  openedCity = false;
  openedDistrict = false;
  openedTown = false;
  serviceError = false;
  isValid = false;
  pageContent: PageContent;
  cashbackEnabled = false;
  isShownIBAN = false;
  isIOS: boolean;
  isAuth: boolean;
  isAuthWarning = false;
  shopperId: string;
  shopperEmail: string;
  orders: Array<IOption> = [];
  categoryName: string;
  brandName: string;
  modelName: string;
  cashbackSelected = false;
  productPrice: number;

  constructor(
    private fb: FormBuilder,
    private selecBoxService: DataService,
    private formDataService: FormDataService,
    private rightSideService: RightSideService,
    private router: Router,
    private navBarService: NavigationBarService
  ) {
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
    this.categoryName = this.rightSideService.getCategoryName();
    this.brandName = this.rightSideService.getBrandName();
    this.productPrice = this.rightSideService.getPrice();
    this.modelName = this.rightSideService.getModelName();
    this.cashbackSelected = this.rightSideService.getCashbackSelected();
    this.pageContent = this.rightSideService.getPageContent();
    this.isAuth = this.rightSideService.getIsAuth();
    this.shopperId = this.rightSideService.getShopperId();
    this.shopperEmail = this.rightSideService.getShopperEmail();
    this.isAuthWarning = this.rightSideService.getIsAuthWarning();
    this.rightSideService.pageContentChange.subscribe(() => {
      this.pageContent = this.rightSideService.getPageContent();
    });
    this.cashbackEnabled = this.rightSideService.getCashbackEnabled();
    this.rightSideService.cashbackEnabledChange.subscribe(val => {
      this.cashbackEnabled = this.rightSideService.getCashbackEnabled();
    });

    if (this.rightSideService.isResultViewed) {
      this.navBarService.clear();
      this.router.navigate(['/']);
    }
    this.lastSeller = this.formDataService.getSeller();
  }

  ngOnInit() {
    const tmpCities = [];
    this.selecBoxService.getCities().subscribe(
      (res: any) => {
        res.forEach(city => {
          tmpCities.push({label: city.name, value: JSON.stringify(city)});
        });
        this.cities = tmpCities;
      }, error => {
        error.errorMessages.forEach(err => {
          this.errorTexts.push(err);
        });
      }
    );
    this.createContactForm();

    const zerothValues = this.formDataService.getZerothTabData();
    if (this.cashbackEnabled && zerothValues && zerothValues.paymentMethod === 'cash') {
      this.contactForm.get('iban').setValidators([Validators.required, ValidatorService.validateIban]);
      this.isShownIBAN = true;
      if (this.isAuthWarning) {
        this.errorTexts.push(this.pageContent.thirdTabCashbackMobileWarning);
      }

      if (this.isAuth && this.shopperId) {
        this.contactForm.get('orderNumber').setValidators([Validators.required]);
        this.selecBoxService.getOrders(this.shopperId).subscribe(
          (res: any) => {
            const arr = [];
            res.forEach(order => {
              arr.push({
                value: order.orderNumber,
                label: order.orderNumber,
                ...order,
              });
            });
            this.orders = arr;
          }, error => {
            error.errorMessages.forEach(err => {
              this.errorTexts.push(err);
            });
          }
        );
      }
    }
  }

  createContactForm() {
    this.contactForm = this.fb.group({
      userId: [this.shopperId],
      isCashback: [this.cashbackEnabled],
      iban: [null],
      orderNumber: [null],
      name: ['', [Validators.required, Validators.maxLength(50)]],
      surname: ['', [Validators.required, Validators.maxLength(50)]],
      identityNumber: ['', [Validators.required, ValidateTcNo]],
      email: [this.shopperEmail, [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, Validators.minLength(10)]],
      address: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(2000)]],
      city: ['', [Validators.required]],
      district: ['', [Validators.required]],
      town: ['', [Validators.required]],
    });

    if (this.lastSeller) {
      Object.keys(this.lastSeller).forEach(name => {
        if (this.contactForm.controls[name]) {
          if (name === 'city' && this.lastSeller[name].length > 0) {
            this.citySelected = false;
            this.selectedCity = true;
            this.contactForm.controls[name].patchValue(this.lastSeller[name]);
            this.getDistricts(JSON.parse(this.lastSeller[name]));
          } else if (name === 'district' && this.lastSeller[name].length > 0) {
            this.selectedDistrict = true;
            this.contactForm.controls[name].patchValue(this.lastSeller[name]);
            this.getTowns(JSON.parse(this.lastSeller[name]));
          } else if (name === 'town' && this.lastSeller[name].length > 0) {
            this.selectedTown = true;
            this.contactForm.controls[name].patchValue(this.lastSeller[name]);
          } else {
            this.contactForm.controls[name].patchValue(this.lastSeller[name]);
          }
        }
      });
    }
  }

  opened() {
    document.getElementsByClassName('filter')[0].id = 'filt';
    document.getElementById('filt').lastElementChild.id = 'inp';
    document.getElementById('inp').blur();
  }

  ngAfterViewInit() {
    if (this.tabSelected !== 4) {
      const elmnt = document.getElementById('navHead');
      const isMobile = detectmob();
      if (isMobile) {
        if (!navigator.userAgent.match(/safari/i) || localStorage == null) {
          // safari || android webview
          parent.postMessage({
            scrollY: (elmnt.getBoundingClientRect().top + this.rightSideService.getTopHeight())
          }, '*');
        } else {
          // ios safari || android tarayıcı
          parent.postMessage({
            scrollY: (elmnt.getBoundingClientRect().top + this.rightSideService.getTopHeight())
          }, '*');
        }
      } else {
        parent.postMessage({
          scrollY: (elmnt.getBoundingClientRect().top + this.rightSideService.getTopHeight())
        }, '*');
      }
    }
  }

  selectCity(city) {
    this.contactForm.controls['district'].patchValue(null);
    this.contactForm.controls['town'].patchValue(null);
    this.towns = [];

    this.getDistricts(JSON.parse(city.value));
  }

  getDistricts(city) {
    const tmpDistricts = [];
    this.selecBoxService.getDistricts(city.id).subscribe(
      (res: any) => {
        this.serviceError = false;
        res.forEach(district => {
          tmpDistricts.push({label: district.name, value: JSON.stringify(district)});
        });
        this.citySelected = false;
        this.districts = tmpDistricts;
      }, error => {
        this.serviceError = true;
        error.errorMessages.forEach(err => {
          this.checkErrorExist(err, this.errorTexts);
        });
      }
    );
  }

  selectDistrict(district) {
    this.contactForm.controls['town'].patchValue(null);
    this.getTowns(JSON.parse(district.value));
  }

  getTowns(district) {
    const tmpTowns = [];
    this.selecBoxService.getTowns(district.externalId).subscribe(
      (res: any) => {

        this.serviceError = false;
        res.forEach(town => {
          tmpTowns.push({label: town.name, value: JSON.stringify(town)});
        });
        this.citySelected = false;
        this.towns = tmpTowns;
      }, error => {
        this.serviceError = true;
        error.errorMessages.forEach(err => {
          this.checkErrorExist(err, this.errorTexts);
        });
      }
    );
  }

  submitForm() {
    if (this.contactForm.valid) {
      this.isValid = true;
      this.seller = this.contactForm.value;
      this.formDataService.setSeller(this.seller);

      const query = this.isShownIBAN ? 'cashback' : 'buyback';

      this.selecBoxService.getPageContents(this.rightSideService.selectedCategoryId, query)
        .subscribe((res: PageContent) => {
          this.rightSideService.setPageContent(res);
        }, error => {
          error.errorMessages.forEach(err => {
            this.errorTexts.push(err);
          });
        });

      this.navBarService.setSelectedTab(this.tabSelected + 1);
      this.sendDavinciEvent('sonrakiAdım');
      this.router.navigate(['/teslimat-adimlari']);
    } else {
      this.isValid = false;
      this.validateAllFormFields(this.contactForm);
    }
  }

  checkErrorExist(errorText: string, errorList: string[]) {
    if (!_.contains(errorList, errorText)) {
      errorList.push(errorText);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  previousPage() {
    this.formDataService.setSeller(this.contactForm.value);
    this.navBarService.setSelectedTab(this.tabSelected - 1);
    this.sendDavinciEvent('önceki');
    this.router.navigate(['/cihaz-durumu']);
  }

  sendDavinciEvent(buttonName) {
    try {
      const orderData = this.orders.find(order => order.value === this.contactForm.get('orderNumber').value);
      hbusApiClient.sendEventRequest('ContactInfo', {
        page_type: 'static',
        page_value: 'eskiyi-getir-yeniyi-gotur',
        stepNo: 4,
        stepName: 'iletisimBilgileri',
        paymentOptions: this.cashbackSelected ? 'cash' : 'coupon',
        brand: this.brandName || '',
        model: this.modelName || '',
        proposedAmount: this.productPrice ?
          // tslint:disable-next-line:radix
          `${parseInt(this.productPrice.toString()).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
          : '',
        buyBackCategory: this.categoryName || '',
        orderInfo: {
          orderId: this.contactForm.get('orderNumber').value || '',
          sku: orderData && orderData['sku'] || '',
          productName: orderData && orderData['product'] && orderData['product'].productName || '',
          productBrand: orderData && orderData['product'] && orderData['product'].brand || '',
        },
        clickButtonInfo: buttonName,
      });
    } catch (e) {
      console.error('error send event', e.message);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/tabs/third-tab/third-tab.component.ts